import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { T, userManager } from '../imports';


interface UserContextType {
    userData: T.UserData;
    userPrefs: T.UserPrefs;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = () => {
    const ctx = useContext(UserContext);
    if (!ctx) throw new Error('useUser must be used within a UserProvider');
    return ctx;
}

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [userDataState, setUserDataState] = useState<T.UserData>(userManager.data);
    const [userPrefsState, setUserPrefsState] = useState<T.UserPrefs>(userManager.prefs);

    useEffect(() => {
        // Sync user when user singleton updates
        userManager.onUserUpdated = (updatedData: T.UserData, updatedPrefs: T.UserPrefs) => {
            // console.log('[UserCtx] User updated:', updatedData, updatedPrefs);
            setUserDataState({ ...updatedData }); // Spread to create new object reference
            setUserPrefsState({ ...updatedPrefs });
        };

        return () => {
            userManager.onUserUpdated = null;
        };
    }, []);

    return (
        <UserContext.Provider value={{ userData: userDataState, userPrefs: userPrefsState }}>
            {children}
        </UserContext.Provider>
    );
}
